// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".vVJ9k9kFZBZ-0NMN67\\+p2g\\=\\={padding:0 var(--xds-spacing-d);padding-bottom:var(--xds-spacing-d);display:flex;flex-direction:column;gap:var(--xds-spacing-d)}", "",{"version":3,"sources":["webpack://./src/shared/components/PIEDrawerNotificationReporter/PIENotificationReporter.module.scss"],"names":[],"mappings":"AAAA,6BACI,8BAAA,CACA,mCAAA,CACA,YAAA,CACA,qBAAA,CACA,wBAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "vVJ9k9kFZBZ-0NMN67+p2g=="
};
export default ___CSS_LOADER_EXPORT___;
